/*
 * @Description:
 * @Author: lyy
 * @Date: 2022-07-21 19:46:54
 * @LastEditors: your Name
 * @LastEditTime: 2022-07-28 15:05:21
 */
import Vue from "vue";
import VueRouter from "vue-router";
//import Store from "@/store";
import routersMap from "./routerConfig";
//import { $setCookie, $getCookie } from "@/utils/utils.js";

Vue.use(VueRouter);

const Router = new VueRouter({
  mode: "hash",
  base: "/",
  routes: routersMap,
});
//免登陆白名单
//const noLoginList = ["login", "register", "myFinance", "applyInsurance", "underwritingManagement", "jumpPage"];

// Router.beforeEach((to, from, next) => {
//   // 如果地址栏中存在token,则重新存入cookie
//   if (to.query.token) $setCookie("token", to.query.token);

//   if ($getCookie("token")) {
//     // 如果已经登录，向登录页面跳转，自动跳转到首页
//     if (to.path == "/login") {
//       next(to.query.goto || "/");
//     } else if (!Store.getters["user/userInfo"].userName) {
//       // 判断vuex中的userInfo是否有值，如果有则继续执行，如果没有则重新请求用户信息【一般刷新页面的时候会重新请求】
//       Store.dispatch("user/Login", {
//         token: to.query.token || $getCookie("token")
//       }).then(() => {
//         // 继续执行后续操作
//         next(to.query.goto || to.fullPath);
//       }).catch(() => { });
//       // console.log("请求接口获取用户信息");
//     } else {
//       next();
//     }
//   } else {
//     // 在免登录名单，直接进入 || 未登录或登录失效,跳转到登录页面
//     next(
//       noLoginList.includes(to.name)
//         ? undefined
//         : { path: "/", query: { goto: to.fullPath } }
//     );
//   }
// });

export default Router;
